/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EducationProgramImageReference } from '../../models/education-program-image-reference';

export interface UpdateEducationProgramImageReference$Params {
  educationProgramId: string;
  id: string;
      body?: EducationProgramImageReference
}

export function updateEducationProgramImageReference(http: HttpClient, rootUrl: string, params: UpdateEducationProgramImageReference$Params, context?: HttpContext): Observable<StrictHttpResponse<EducationProgramImageReference>> {
  const rb = new RequestBuilder(rootUrl, updateEducationProgramImageReference.PATH, 'put');
  if (params) {
    rb.path('educationProgramId', params.educationProgramId, {});
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EducationProgramImageReference>;
    })
  );
}

updateEducationProgramImageReference.PATH = '/educationprogram/{educationProgramId}/images/{id}';
